import React from 'react'
import HeroBanner from '../component/Common Banner Component/HeroBanner'
import Footer from '../component/Footer/Footer'

function Contact() {
  return (
    <div>

        <HeroBanner
            bgImg={"/images/creatives/gradient-bg-3.png"}
            serviceForm={true}
            sideLinks={false}
            Heading="Contact Us"
            socialLinks={true}
        />

        <Footer
            newsletterSection={false}
        />
    </div>
  )
}

export default Contact